import React, { useState } from 'react'
import { Box, Button, Typography } from '@mui/material'

const CLAMP_LINES = 4

interface JobContextNoteProps {
  /** The organisation and job context from Admin → Context; empty when none is set. */
  jobContext?: string
  onOpenJobContext: () => void
}

// The client and job context ThemeAI reads alongside the task's own (Adam,
// 23 Sep: "we can't see the context in the UI"). Read-only here; it is edited
// in Admin → Context, where Tables insights read the same text.
const JobContextNote: React.FC<JobContextNoteProps> = ({ jobContext, onOpenJobContext }) => {
  const [expanded, setExpanded] = useState(false)
  const text = jobContext?.trim() || ''
  const long = text.split('\n').length > CLAMP_LINES || text.length > 400

  return (
    <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1, bgcolor: 'action.hover', px: 2, py: 1.5 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: text ? 0.5 : 0 }}>
        <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
          {text ? 'Also used: the client and job context' : 'No client or job context is set for this job.'}
        </Typography>
        <Box sx={{ flex: 1 }} />
        <Button size="small" color="info" onClick={onOpenJobContext}>
          {text ? 'Edit in Admin → Context' : 'Add it in Admin → Context'}
        </Button>
      </Box>
      {text && (
        <>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              ...(long && !expanded
                ? { display: '-webkit-box', WebkitLineClamp: CLAMP_LINES, WebkitBoxOrient: 'vertical', overflow: 'hidden' }
                : {}),
            }}
          >
            {text}
          </Typography>
          {long && (
            <Button size="small" color="info" onClick={() => setExpanded((open) => !open)} sx={{ mt: 0.5, ml: -1 }}>
              {expanded ? 'Show less' : 'Show all'}
            </Button>
          )}
        </>
      )}
    </Box>
  )
}

export default JobContextNote
